import React, { useEffect, useState } from "react";
import { http } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function CollectionsPage() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    http.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const grouped = {
    principala: products.filter((p) => p.collection === "principala"),
    halloween: products.filter((p) => p.collection === "halloween"),
    bundle: products.filter((p) => p.collection === "bundle"),
  };

  const sections = [
    { id: "principala", label: "Ediția Principală", description: "Prima carte Vis de Zi — ilustrații feminine, fantastice, atemporale.", color: "var(--vdz-navy)" },
    { id: "halloween", label: "Colecția Halloween", description: "Ediție sezonieră — ilustrații misterioase pentru nopțile lungi de toamnă.", color: "var(--vdz-burnt-orange)" },
    { id: "bundle", label: "Pachete Speciale", description: "Economisești când cumperi mai multe cărți împreună.", color: "var(--vdz-burgundy)" },
  ];

  return (
    <div className="py-16 md:py-24" data-testid="collections-page">
      <div className="container-vdz">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="eyebrow mb-3">Colecții</div>
          <h1 className="font-serif-display text-5xl md:text-6xl" style={{ color: "var(--vdz-navy)" }}>Pentru fiecare anotimp al visului.</h1>
          <p className="mt-5 opacity-75 leading-relaxed">
            Fiecare ediție Vis de Zi este o lume în sine — creată pentru un moment, pentru un sezon, pentru o stare.
          </p>
        </div>

        {sections.map((s) => (
          grouped[s.id].length > 0 && (
            <section key={s.id} className="mb-20">
              <div className="flex items-end gap-5 mb-10">
                <div className="w-14 h-14 shrink-0" style={{ background: s.color }} />
                <div>
                  <div className="eyebrow mb-1">Colecție</div>
                  <h2 className="font-serif-display text-3xl md:text-4xl" style={{ color: "var(--vdz-navy)" }}>{s.label}</h2>
                  <p className="opacity-70 text-sm mt-1 max-w-xl">{s.description}</p>
                </div>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {grouped[s.id].map((p) => <ProductCard key={p.id} product={p} />)}
              </div>
            </section>
          )
        ))}

        <div className="mt-16 p-10 md:p-16 text-center border" style={{ borderColor: "var(--vdz-cream-border)", background: "var(--vdz-cream-warm)" }}>
          <div className="eyebrow mb-3">Vin în curând</div>
          <h3 className="font-serif-display text-3xl md:text-4xl" style={{ color: "var(--vdz-navy)" }}>Primăvara · Vara · Iarna</h3>
          <p className="mt-4 opacity-70 max-w-xl mx-auto">
            Noile ediții sezoniere sunt în lucru. Înscrie-te la newsletter pentru a fi prima care află când apar.
          </p>
        </div>
      </div>
    </div>
  );
}
